import cooperplaceApi from 'services/apis/cooperplace';

function normalizeGroup(row = {}) {
  const empresasArr = Array.isArray(row.empresasVinculadas)
    ? row.empresasVinculadas
    : Array.isArray(row.empresas)
      ? row.empresas
      : [];

  const principalName =
    row?.principal?.socialName ??
    row?.principal?.social_name ??
    null;

  const principalDoc =
    row?.principal?.cpfCnpj ??
    row?.principal?.document ??
    row.cnpjPrincipal ??
    row.cgcCpf ??
    row.cgccpf ??
    null;

  return {
    id: row.id ?? row.externalId ?? row.grupoHandle ?? row.handle ?? null,

    nome:
      row.nome ??
      row.razaoSocial ??
      row.social_name ??
      row.descricao ??
      principalName ??
      (principalDoc || ''),

    vencimento:
      row.vencimento ??
      row.vencimentoLimite ??
      row.vencimento_limite ??
      row.dueDate ??
      row.due_date ??
      row.GLVENCIMENTO ??
      null,

    quantidadeEmpresas:
      row.quantidadeEmpresas ??
      empresasArr.length ??
      row.empresasVinculadas?.length ??
      row.empresas?.length ??
      row.cnpjs?.length ??
      0,

    cnpjPrincipal:
      row.cnpjPrincipal ??
      row.cgcCpf ??
      row.cgccpf ??
      row?.principal?.cpfCnpj ??
      row?.principal?.document ??
      null,

    valorLiberado: Number(row.valorLiberado ?? row.releasedValue ?? 0),
    valorPermitido: Number(row.valorPermitido ?? row.allowedValue ?? 0),
    observacao: row.observacao ?? row.obs ?? null,

    empresasVinculadas: empresasArr.map((e) => ({
      id: e.id ?? null,
      nome: e.nome ?? e.social_name ?? e.razaoSocial ?? '',
      cnpj:
        e.cnpj ??
        e.cgcCpf ??
        e.cgccpf ??
        e.document ??
        null,
    })),

    cnpjs: Array.isArray(row.cnpjs)
      ? row.cnpjs
      : empresasArr
        .map(
          (e) =>
            e.cnpj ??
            e.cgcCpf ??
            e.cgccpf ??
            e.document
        )
        .filter(Boolean),

    externalId: row.externalId ?? row.grupoHandle ?? null,
  };
}


export async function listBusinessGroups({ page = 1, perPage = 20, q } = {}) {
  const { data } = await cooperplaceApi.get('business-groups', {
    params: { page, perPage, q },
  });

  const arr = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];

  return {
    data: arr.map(normalizeGroup),
    page: Number(data?.meta?.current_page ?? data?.page ?? page),
    lastPage: Number(data?.meta?.last_page ?? data?.lastPage ?? 1),
    total: Number(data?.meta?.total ?? data?.total ?? arr.length),
  };
}

export async function importBusinessGroupsFromBenner({
  page = 1,
  perPage = 20,
  includePersons = false,
} = {}) {
  const { data } = await cooperplaceApi.get('business-groups/import', {
    params: {
      page,
      perPage,
      includePersons: includePersons ? 1 : 0,
    },
  });

  const list = Array.isArray(data?.data)
    ? data.data
    : Array.isArray(data?.groups)
      ? data.groups
      : [];

  return {
    success: !!data?.success,
    imported: Number(data?.imported ?? 0),
    groupsUpserted: Number(data?.groupsUpserted ?? 0),
    personsCreated: Number(data?.personsCreated ?? 0),
    pivots: Number(data?.pivots ?? 0),
    page: Number(data?.page ?? page),
    lastPage: Number(data?.lastPage ?? 1),
    perPage: Number(data?.perPage ?? perPage),
    total: Number(data?.total ?? list.length),
    data: list.map(normalizeGroup),
  };
}

export async function showBusinessGroup(idOrExternal) {
  const isNumericId = /^\d+$/.test(String(idOrExternal ?? ''));
  if (isNumericId) {
    const { data } = await cooperplaceApi.get(`business-groups/${idOrExternal}`);
    return normalizeGroup(data);
  }
  const { data } = await cooperplaceApi.get('business-groups/0', {
    params: { externalId: idOrExternal },
  });
  return normalizeGroup(data);
}

export async function resumoBusinessGroup(cgccpf) {
  const { data } = await cooperplaceApi.get('business-groups/resumo', {
    params: { cgccpf: String(cgccpf || '').toUpperCase().replace(/[^A-Z0-9]/g, '') },
  });
  return {
    grupos: Array.isArray(data?.grupos) ? data.grupos.map(normalizeGroup) : [],
  };
}

export async function forSelectBusinessGroups({ search = '', ids = [] } = {}) {
  const { data } = await cooperplaceApi.get('business-groups/for-select', {
    params: { search: String(search || '').trim(), ids },
  });

  return data
}
